<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h1>I<sub>MVM</sub> Team</h1>
        <div class="row contact" v-for="contact in contacts" :key="contact.name">
            <div class="col-md-4">
              <div class="profile_pic">
                  <img :src="contact.image" :alt="contact.name">
              </div>
            </div>
            <div class="contactinfo col-md-8">
              <h3>{{ contact.name }}</h3>
              <h4>{{ contact.role }}</h4>
              <hr>
              <address>
                  <div>
                    <span class="icon-small icon-phone"></span>
                    <span>{{ contact.mobile }}</span>
                  </div>
                  <hr>
                  <a class="icon-small icon-envelop" :href="contact.email"></a>
                  <a class="icon-small icon-linkedin2" :href="contact.linkedin"></a>
              </address>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/css/_variables.scss';
  @import '@/assets/css/icons.scss';

  .profile_pic img {
      width: 12em;
      height: 12em;
      border: 0.5em solid rgba(0,0,0,.1);
      border-radius: 50%;
      margin: 2em;
  }

  .contact {
    margin: 1em 0;
    width: 100%;
    max-width: 800px;
    border-radius: 10px;
    color: $font_color1;
    background-color: rgba(60,90,140,.3);
    box-shadow: 1px 1px 3px 1px $font_color2;
  }

  .contact h4 {
      color: $font_color1;
  }

  .contact h3 {
      color: $font_color1;
      border-color: $font_color1;
  }

  .contact a {
    color: $bg_color1;
  }

  .contact a:hover {
    color: $font_color1;
  }

  .contactinfo {
    padding-top: 2em;
  }
</style>

<script>
  export default {
    name: 'team',
    data() {
      return {
        contacts: [
          {
            name: 'Qinqin Zeng',
            role: "PhD Candidate",
            mobile: "+31 6 45 35 10 57",
            email: "mailto:qinqinzeng618@gmail.com",
            linkedin: "https://www.linkedin.com/in/qinqin-zeng/",
            image: require("@/assets/img/profile/qinqin.png")
          },
          {
            name: 'Wouter Beelaerts van Blokland',
            role: "Doctor",
            mobile: "+31 15 27 86680",
            email: "mailto:W.W.A.BeelaertsvanBlokland@tudelft.nl",
            linkedin: "https://www.linkedin.com/in/wouter-w-a-beelaerts-van-blokland-5388386/?originalSubdomain=nl",
            image: require("@/assets/img/profile/wouter.jpg")
          },
          {
            name: 'Gabriel Lodewijks',
            role: "Professor",
            mobile: "+61 (2) 9385 7183",
            email: "mailto:g.lodewijks@unsw.edu.au",
            linkedin: "https://www.linkedin.com/in/gabriel-lodewijks-902a20a/?originalSubdomain=au",
            image: require("@/assets/img/profile/gabriel.jpg")
          },
          {
            name: 'Sicco Santema',
            role: "Professor",
            mobile: "+31 (0)15 27 83076",
            email: "mailto:S.C.Santema@tudelft.nl",
            linkedin: "https://www.linkedin.com/in/siccosantema",
            image: require("@/assets/img/profile/santema.jpg")
          },
          {
            name: 'Sébastien Keppens',
            role: "Web Developer",
            mobile: "+32 488 71 55 01",
            email: "mailto:sebastien_keppens@live.com",
            linkedin: "https://nl.linkedin.com/in/sébastien-keppens-71a06216a",
            image: require("@/assets/img/profile/sebastien.jpg")
          }
        ]
      }
    },
    components: {

    }
  }
</script>
